export type WeatherLocation = {
  city: string;
  country: string;
  /**
   * ISO 3166-1 alpha-2. Antes era una unión de tres países porque el catálogo era
   * fijo; ahora el usuario busca la ciudad que quiera, así que cabe cualquiera.
   */
  countryCode: string;
  displayName: string;
  /** Coordenadas, si la ciudad vino del buscador. Ahorran el geocoding en cada consulta. */
  lat?: number;
  lon?: number;
};

/**
 * Bandera a partir del código ISO, sin tabla que mantener: cada letra se mapea a su
 * indicador regional (A = U+1F1E6) y el par forma el emoji. Sirve para cualquier país.
 */
export function flagFromCountryCode(code?: string): string {
  const cc = (code || "").trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return "🏳️";
  return String.fromCodePoint(...[...cc].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
}

export const WEATHER_LOCATIONS: WeatherLocation[] = [
  // España
  { city: "Almería", country: "España", countryCode: "ES", displayName: "Almería, España" },
  { city: "Níjar", country: "España", countryCode: "ES", displayName: "Níjar, España" },
  { city: "El Ejido", country: "España", countryCode: "ES", displayName: "El Ejido, España" },
  { city: "Roquetas de Mar", country: "España", countryCode: "ES", displayName: "Roquetas de Mar, España" },
  { city: "Murcia", country: "España", countryCode: "ES", displayName: "Murcia, España" },
  { city: "Cartagena", country: "España", countryCode: "ES", displayName: "Cartagena, España" },
  { city: "Madrid", country: "España", countryCode: "ES", displayName: "Madrid, España" },
  { city: "Barcelona", country: "España", countryCode: "ES", displayName: "Barcelona, España" },
  { city: "Valencia", country: "España", countryCode: "ES", displayName: "Valencia, España" },
  { city: "Sevilla", country: "España", countryCode: "ES", displayName: "Sevilla, España" },
  { city: "Málaga", country: "España", countryCode: "ES", displayName: "Málaga, España" },
  { city: "Granada", country: "España", countryCode: "ES", displayName: "Granada, España" },
  { city: "Huelva", country: "España", countryCode: "ES", displayName: "Huelva, España" },
  { city: "Córdoba", country: "España", countryCode: "ES", displayName: "Córdoba, España" },
  { city: "Alicante", country: "España", countryCode: "ES", displayName: "Alicante, España" },
  { city: "Zaragoza", country: "España", countryCode: "ES", displayName: "Zaragoza, España" },
  { city: "Badajoz", country: "España", countryCode: "ES", displayName: "Badajoz, España" },

  // Reino Unido
  { city: "London", country: "United Kingdom", countryCode: "GB", displayName: "London, UK" },
  { city: "Manchester", country: "United Kingdom", countryCode: "GB", displayName: "Manchester, UK" },
  { city: "Birmingham", country: "United Kingdom", countryCode: "GB", displayName: "Birmingham, UK" },
  { city: "Leeds", country: "United Kingdom", countryCode: "GB", displayName: "Leeds, UK" },
  { city: "Glasgow", country: "United Kingdom", countryCode: "GB", displayName: "Glasgow, UK" },
  { city: "Edinburgh", country: "United Kingdom", countryCode: "GB", displayName: "Edinburgh, UK" },
  { city: "Bristol", country: "United Kingdom", countryCode: "GB", displayName: "Bristol, UK" },
  { city: "Cambridge", country: "United Kingdom", countryCode: "GB", displayName: "Cambridge, UK" },

  // Portugal
  { city: "Lisboa", country: "Portugal", countryCode: "PT", displayName: "Lisboa, Portugal" },
  { city: "Porto", country: "Portugal", countryCode: "PT", displayName: "Porto, Portugal" },
  { city: "Faro", country: "Portugal", countryCode: "PT", displayName: "Faro, Portugal" },
  { city: "Évora", country: "Portugal", countryCode: "PT", displayName: "Évora, Portugal" },
  { city: "Coimbra", country: "Portugal", countryCode: "PT", displayName: "Coimbra, Portugal" },
  { city: "Braga", country: "Portugal", countryCode: "PT", displayName: "Braga, Portugal" },
];

/**
 * Ciudad de partida de toda cuenta nueva. Lleva las coordenadas puestas para que la
 * primera consulta del tiempo no dependa de acertar con el nombre en ningún idioma.
 */
export const DEFAULT_LOCATION: WeatherLocation = {
  city: "Almería",
  country: "España",
  countryCode: "ES",
  displayName: "Almería, España",
  lat: 36.83814,
  lon: -2.45974,
};

export const COUNTRY_FLAGS: Record<string, string> = {
  ES: "🇪🇸",
  GB: "🇬🇧",
  PT: "🇵🇹",
};

/**
 * WEATHER_LOCATIONS ya no alimenta el selector del tiempo \u2014 ah\u00ed ahora se busca
 * cualquier ciudad del mundo. La lista se queda porque de ella sale la lista de
 * pa\u00edses de las plagas predeterminadas (AddPresetPestsDialog).
 */
